import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.trim.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/* eslint-disable */


import { handle } from "@dp/common";
var LITERALS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

var Core = /*#__PURE__*/function () {
  function Core(config, axios) {
    _classCallCheck(this, Core);

    _defineProperty(this, "coreRequestHandlerIndex", 0);

    _defineProperty(this, "coreResponseHandlerIndex", 0);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
    this.coreRequestHandlerIndex = axios.interceptors.request.use(this.coreRequestInterceptor.bind(this));
    this.coreResponseHandlerIndex = axios.interceptors.response.use(this.coreResponseInterceptor.bind(this));
  }

  _createClass(Core, [{
    key: "base64Encode",
    value: function base64Encode(input) {
      var output = ""; // tslint:disable-next-line:one-variable-per-declaration

      var chr1,
          chr2,
          chr3 = -1; // tslint:disable-next-line:one-variable-per-declaration

      var enc1,
          enc2,
          enc3,
          enc4 = -1;
      var i = 0;

      do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++); // tslint:disable-next-line:no-bitwise

        enc1 = chr1 >> 2; // tslint:disable-next-line:no-bitwise

        enc2 = (chr1 & 3) << 4 | chr2 >> 4; // tslint:disable-next-line:no-bitwise

        enc3 = (chr2 & 15) << 2 | chr3 >> 6; // tslint:disable-next-line:no-bitwise

        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output + LITERALS.charAt(enc1) + LITERALS.charAt(enc2) + LITERALS.charAt(enc3) + LITERALS.charAt(enc4);
        chr1 = chr2 = chr3 = -1;
        enc1 = enc2 = enc3 = enc4 = -1;
      } while (i < input.length);

      return output;
    }
  }, {
    key: "handle",
    value: function handle(promise, errorExt) {
      return promise.then(function (data) {
        return [null, data];
      })["catch"](function (err) {
        if (errorExt) {
          Object.assign(err, errorExt);
        }

        return [err, undefined];
      });
    }
  }, {
    key: "hashCode",
    value: function hashCode(obj) {
      if (obj) {
        var str = typeof obj === "string" ? obj : this.sortedStringify(obj, null);

        if (str) {
          return str.split("").reduce(function (prevHash, currVal) {
            return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
          }, 0) + "";
        } else {
          return str;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "sortedStringify",
    value: function sortedStringify(obj, sorter) {
      var sortedKeys = Object.keys(obj).map(function (key) {
        return [key, obj[key]];
      }).map(this.flattenEntries).reduce(function (acc, arr) {
        return acc.concat(arr);
      }, []).sort(sorter || undefined).map(function (entry) {
        return entry[0];
      });
      return JSON.stringify(obj, sortedKeys);
    }
  }, {
    key: "decodeBase64",
    value: function decodeBase64(input) {
      var output = ""; // tslint:disable-next-line:one-variable-per-declaration

      var chr1,
          chr2,
          chr3 = -1; // tslint:disable-next-line:one-variable-per-declaration

      var enc1,
          enc2,
          enc3,
          enc4 = -1;
      var i = 0; // remove all characters that are not A-Z, a-z, 0-9, +, /, or =

      var base64test = /[^A-Za-z0-9\+\/\=]/g;

      if (base64test.exec(input)) {
        return null;
      }

      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

      do {
        enc1 = LITERALS.indexOf(input.charAt(i++));
        enc2 = LITERALS.indexOf(input.charAt(i++));
        enc3 = LITERALS.indexOf(input.charAt(i++));
        enc4 = LITERALS.indexOf(input.charAt(i++)); // tslint:disable-next-line:no-bitwise

        chr1 = enc1 << 2 | enc2 >> 4; // tslint:disable-next-line:no-bitwise

        chr2 = (enc2 & 15) << 4 | enc3 >> 2; // tslint:disable-next-line:no-bitwise

        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);

        if (enc3 !== 64) {
          output = output + String.fromCharCode(chr2);
        }

        if (enc4 !== 64) {
          output = output + String.fromCharCode(chr3);
        }

        chr1 = chr2 = chr3 = -1;
        enc1 = enc2 = enc3 = enc4 = -1;
      } while (i < input.length);

      return output;
    }
  }, {
    key: "registerRequestInterceptor",
    value: function registerRequestInterceptor(onFulfilled, onRejected) {
      var interceptorManager = this.axios.interceptors.request;
      interceptorManager.eject(this.coreRequestHandlerIndex);
      var ret = interceptorManager.use(onFulfilled, onRejected);
      this.coreRequestHandlerIndex = interceptorManager.use(this.coreRequestInterceptor.bind(this));
      return ret;
    }
  }, {
    key: "registerResponseInterceptor",
    value: function registerResponseInterceptor(onFulfilled, onRejected) {
      var interceptorManager = this.axios.interceptors.response;
      interceptorManager.eject(this.coreResponseHandlerIndex);
      var ret = interceptorManager.use(onFulfilled, onRejected);
      this.coreResponseHandlerIndex = interceptorManager.use(this.coreResponseInterceptor.bind(this));
      return ret;
    }
  }, {
    key: "deRegisterRequestInterceptor",
    value: function deRegisterRequestInterceptor(idx) {
      var interceptorManager = this.axios.interceptors.request;

      if (idx !== this.coreRequestHandlerIndex) {
        try {
          interceptorManager.eject(idx);
          --this.coreRequestHandlerIndex;
        } catch (e) {}
      } else {
        throw new Error("Invalid Idx passed");
      }
    }
  }, {
    key: "deRegisterResponseInterceptor",
    value: function deRegisterResponseInterceptor(idx) {
      var interceptorManager = this.axios.interceptors.response;

      if (idx !== this.coreResponseHandlerIndex) {
        try {
          interceptorManager.eject(idx);
          --this.coreResponseHandlerIndex;
        } catch (e) {}
      } else {
        throw new Error("Invalid Idx passed");
      }
    }
  }, {
    key: "resetInterceptors",
    value: function resetInterceptors() {
      var responseInterceptorManager = this.axios.interceptors.response;
      var requestInterceptorManager = this.axios.interceptors.request;
      responseInterceptorManager.handlers.splice(0, responseInterceptorManager.handlers.length);
      requestInterceptorManager.handlers.splice(0, requestInterceptorManager.handlers.length);
      this.coreResponseHandlerIndex = responseInterceptorManager.use(this.coreResponseInterceptor.bind(this));
      this.coreRequestHandlerIndex = requestInterceptorManager.use(this.coreRequestInterceptor.bind(this));
    }
  }, {
    key: "procesResponseData",
    value: function procesResponseData(data) {
      var dataObj = null;

      if (data) {
        if (typeof data === "string") {
          try {
            dataObj = JSON.parse(data);
          } catch (err) {// ignore any errors
          }
        } else {
          dataObj = data;
        }

        return dataObj;
      } else {
        return data;
      }
    }
  }, {
    key: "resolveUrl",
    value: function resolveUrl(requestUrl) {
      var _prefixes$DEFAULT_SER;

      var prefixes = this.config.getPrefix();
      var serviceApiPrefixes = prefixes.SERVICES_API_PREFIXES;
      var defaultApiPrefix = (_prefixes$DEFAULT_SER = prefixes.DEFAULT_SERVICES_API_PREFIX) !== null && _prefixes$DEFAULT_SER !== void 0 ? _prefixes$DEFAULT_SER : "";
      var found = false;
      var resolvedUrl = requestUrl;

      if (serviceApiPrefixes) {
        Object.keys(serviceApiPrefixes).forEach(function (context) {
          var prefix = serviceApiPrefixes[context];
          var contextFound = requestUrl.indexOf(context) === 0;
          var prefixAndContextFound = requestUrl.indexOf(prefix + context) === 0;

          if (contextFound || prefixAndContextFound) {
            found = true;
            resolvedUrl = contextFound ? prefix + requestUrl : requestUrl;
          }
        });
      }

      if (!found) {
        if (requestUrl.indexOf("http") === 0) {
          if (requestUrl.indexOf(defaultApiPrefix) === 0) {
            found = true;
          }
        } else {
          resolvedUrl = defaultApiPrefix + requestUrl;
          found = true;
        }
      }

      return {
        resolvedUrl: resolvedUrl,
        isApiRequest: found
      };
    }
  }, {
    key: "coreResponseInterceptor",
    value: function coreResponseInterceptor(response) {
      var _this = this;

      var requestConfig = response.config;
      var url = requestConfig.url;

      var _this$resolveUrl = this.resolveUrl(url),
          isApiRequest = _this$resolveUrl.isApiRequest;

      var responseHeaders = response.headers;
      var data = response.data;
      var responseContentType = responseHeaders ? responseHeaders["content-type"] : null;
      var isResponseJson = responseContentType ? responseContentType.indexOf("json") > 0 : null;

      if (isApiRequest) {
        if (isResponseJson) {
          var processed = this.procesResponseData(response.data);
          response.data = processed;

          if (processed && processed.errorResponse) {
            throw {
              config: response.config,
              request: response.request,
              response: {
                data: processed.errorResponse
              }
            };
          }
        }

        if (data && typeof data === "string" && data[0] === "<") {
          // XML Response
          var xmlenc = this.config.getMessageEncryptionUtil();
          var xmlencOpts = this.config.getMessageEncryptionOpts();

          if (xmlenc && xmlencOpts && typeof xmlenc.decryptPayload === "function") {
            return new Promise( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                var _yield$handle, _yield$handle2, error, decryptedResponse, _processed;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return handle(xmlenc.decryptPayload(data, xmlencOpts.privateKey));

                      case 2:
                        _yield$handle = _context.sent;
                        _yield$handle2 = _slicedToArray(_yield$handle, 2);
                        error = _yield$handle2[0];
                        decryptedResponse = _yield$handle2[1];

                        if (error) {
                          resolve(response);
                        } else {
                          _processed = _this.procesResponseData(decryptedResponse);
                          response.data = _processed;

                          if (_processed && _processed.errorResponse) {
                            reject({
                              config: response.config,
                              request: response.request,
                              response: {
                                data: _processed.errorResponse
                              }
                            });
                          } else {
                            resolve(response);
                          }
                        }

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x, _x2) {
                return _ref.apply(this, arguments);
              };
            }());
          }
        }
      }

      return response;
    }
  }, {
    key: "getUrlParams",
    value: function getUrlParams(url) {
      var obj = {};

      if (url) {
        var queryString = url.split("?")[1];

        if (queryString) {
          queryString = queryString.split("#")[0];
          var arr = queryString.split("&");

          var _iterator = _createForOfIteratorHelper(arr),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var itm = _step.value;
              var a = itm.split("=");
              var paramNum = void 0;
              var paramName = a[0].replace(/\[\d*\]/, function (v) {
                paramNum = v.slice(1, -1);
                return "";
              });
              var paramValue = typeof a[1] === "undefined" ? "" : a[1];
              paramName = decodeURIComponent(paramName);
              paramValue = decodeURIComponent(paramValue);

              if (obj[paramName]) {
                if (typeof obj[paramName] === "string") {
                  obj[paramName] = [obj[paramName]];
                }

                if (typeof paramNum === "undefined") {
                  obj[paramName].push(paramValue);
                } else {
                  obj[paramName][paramNum] = paramValue;
                }
              } else {
                obj[paramName] = paramValue;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      return obj;
    }
  }, {
    key: "coreRequestInterceptor",
    value: function coreRequestInterceptor(requestConfig) {
      var _this2 = this;

      var url = requestConfig.url;
      var prefixes = this.config.getPrefix();
      var env = prefixes.ENV;
      var urlHash = this.hashCode(url);

      var _this$resolveUrl2 = this.resolveUrl(url),
          resolvedUrl = _this$resolveUrl2.resolvedUrl,
          isApiRequest = _this$resolveUrl2.isApiRequest;

      url = resolvedUrl;

      if (isApiRequest) {
        // DP API Request
        var reqConfigParams = requestConfig.params;
        var reqConfigHeaders = requestConfig.headers;
        var urlNoParams = url.split("?")[0];
        var urlParams = this.getUrlParams(url);
        var commonParams = this.config.getCommonQueryParams();
        var configHeaders = this.config.getCommonHeaders();
        var commonHeaders = configHeaders ? _objectSpread(_objectSpread({}, configHeaders), {}, {
          "X-API-ID": urlHash
        }) : {
          "X-API-ID": urlHash
        };
        var resParams = env ? _objectSpread(_objectSpread(_objectSpread({
          environment: env
        }, commonParams), urlParams), reqConfigParams) : _objectSpread(_objectSpread(_objectSpread({}, commonParams), urlParams), reqConfigParams);
        var noTag = resParams.noTag;

        if (noTag) {
          Object.keys(commonHeaders).forEach(function (key) {
            var upperKey = key.toUpperCase();

            if (upperKey.indexOf("X-") >= 0 || upperKey.indexOf("RETRY") >= 0) {
              delete commonHeaders[key];
            }
          });
        }

        for (var par in resParams) {
          if (par) {
            var paramVal = resParams[par];

            if (paramVal && paramVal[0] !== "{") {
              urlNoParams = urlNoParams.replace(["{", par, "}"].join(""), paramVal ? encodeURIComponent(paramVal) : "");
            } else {
              delete resParams[par];
            }
          }
        }

        requestConfig.paramsSerializer = function (paramsToSerialize) {
          var queryParams = [];

          if (paramsToSerialize) {
            for (var resParamKey in paramsToSerialize) {
              if (resParamKey) {
                var val = paramsToSerialize[resParamKey];

                if (Array.isArray(val)) {
                  var _iterator2 = _createForOfIteratorHelper(val),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var arrVal = _step2.value;
                      queryParams.push([resParamKey, encodeURIComponent(arrVal)].join("="));
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                } else {
                  queryParams.push([resParamKey, encodeURIComponent(val)].join("="));
                }
              }
            }
          }

          return queryParams.join("&");
        };

        requestConfig.params = resParams;
        requestConfig.url = urlNoParams;
        requestConfig.headers = commonHeaders ? _objectSpread(_objectSpread({}, reqConfigHeaders), commonHeaders) : reqConfigHeaders;
      }

      if (requestConfig.method === "post" || requestConfig.method === "put") {
        var xmlenc = this.config.getMessageEncryptionUtil();
        var xmlencOpts = this.config.getMessageEncryptionOpts();
        var headers = requestConfig.headers;

        if (headers && headers["enc"] && xmlenc && xmlencOpts && typeof xmlenc.encryptPayload === "function") {
          delete requestConfig.headers["enc"];
          var data = requestConfig.data;

          if (data) {
            if (typeof data === "string") {
              data = data.trim();

              if (data[0] === "<") {
                var _data;

                requestConfig.data = data.trim();
                requestConfig.headers["Content-Length"] = (_data = data) === null || _data === void 0 ? void 0 : _data.length;
                requestConfig.headers["Content-Type"] = "application/xml";
                return requestConfig;
              } else {
                data = JSON.parse(data);
              }
            }

            return new Promise( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                var base64PEM, _yield$handle3, _yield$handle4, error, result;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        base64PEM = _this2.base64Encode(xmlencOpts.PEM);
                        _context2.next = 3;
                        return handle(xmlenc.encryptPayload(JSON.stringify(data), xmlencOpts.RSAPublicKey, _this2.extractCertificateFromPEM(xmlencOpts.PEM)));

                      case 3:
                        _yield$handle3 = _context2.sent;
                        _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                        error = _yield$handle4[0];
                        result = _yield$handle4[1];

                        if (!error) {
                          requestConfig.headers["Content-Length"] = result === null || result === void 0 ? void 0 : result.length;
                          requestConfig.headers["Content-Type"] = "application/xml";
                          requestConfig.data = result;
                        }

                        resolve(requestConfig);

                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        }
      }

      return requestConfig;
    }
  }, {
    key: "extractCertificateFromPEM",
    value: function extractCertificateFromPEM(pem) {
      var begin = "-----BEGIN CERTIFICATE-----";
      var end = "-----END CERTIFICATE-----";
      var trimmed = pem.replace(begin, "");
      return trimmed.replace(end, "");
    }
  }, {
    key: "flattenEntries",
    value: function flattenEntries(entry) {
      var key = entry[0];
      var value = entry[1];

      if (typeof value !== "object") {
        return [[key, value]];
      }

      var nestedEntries = Object.keys(value).map(function (mapKey) {
        return [mapKey, value[mapKey]];
      }).map(this.flattenEntries).reduce(function (acc, arr) {
        return acc.concat(arr);
      }, []);
      nestedEntries.unshift([key, value]);
      return nestedEntries;
    }
  }]);

  return Core;
}();

export { Core as default };